// tinymce-loader.ts
let loader: Promise<void> | null = null;

export function loadTinyMCEScript(): Promise<void> {
  if (loader) return loader;
  loader = new Promise<void>((resolve, reject) => {
    if (window.tinymce) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = "/tinymce/js/tinymce/tinymce.min.js";
    script.referrerPolicy = "origin";
    script.onload = () => resolve();
    script.onerror = () => reject("No se pudo cargar TinyMCE");
    document.body.appendChild(script);
  });
  return loader;
}
